import { Injectable } from '@angular/core';
import { API, Auth } from 'aws-amplify';
import { environment } from 'environments/environment';
import { AuthService } from '../auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class PushService
{
    private _pushUrl: string = '/push';
    private _apiName: string = environment.pushApiName;

    /**
     * Constructor
    */
    constructor(private _authService: AuthService)
    {
    }

    async registerSubscription(subscription: PushSubscriptionJSON, station: [string]): Promise<boolean> {
      const headers = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
      };
      const body = {};
      const options = {headers: headers, body: body};

      let path = `${this._pushUrl}/register-subscription?`;
      path += `station=${station.join('%26')}`;
      path += `&user=${this._authService.currentUser.email}`;
      path += `&subscription=${JSON.stringify(subscription)}`;

      console.log("registerSubscription url", path);

      const promise = API.get(this._apiName, path, options).then(
          (result) => {
            console.log('register-subscription result', result);
            return result.item;
          },
          (err) => {
            console.log("registerSubscription error", err);
            throw(err);
          }
      );
      
      return promise;
    }

    async unRegisterSubscription(): Promise<boolean> {
      const headers = {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}`
      };
      const body = {};
      const options = {headers: headers, body: body};

      let path = `${this._pushUrl}/unregister-subscription`;

      console.log("unRegisterSubscription url", path);

      const promise = API.get(this._apiName, path, options).then(
          (result) => {
            console.log('unregister-subscription result', result);
            return result.item;
          },
          (err) => {
            console.log("unRegisterSubscription error", err);
            throw(err);
          }
      );
      
      return promise;
    }


}